import { useState, useEffect } from "react";
import { BrowserRouter } from "react-router-dom";
import { AppRoute } from "./routes/AppRoute";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import { useCurrentCompany} from "./hooks";
import { SpinerLoad } from "./components/templateComponents/SpinerLoad";
import { LoadParameter } from "./helpers/Parameter";
import { useCompany } from "./hooks/templateHooks/useCompany";
import {ErrorServer} from './pages/ErrorServer'
import { useSpinLoadStore } from "./store/useSpinLoadStore";



export const App = () => {
  const { GetCurrentCompany, setCurrentCompany, Company, SelectedCompany } =
    useCurrentCompany();
  const CompanyHook = useCompany();

  const [HasErrorLoadCompany, setHasErrorLoadCompany] = useState();
  const {ShowLoad, HideLoad} = useSpinLoadStore();
  const [theme, settheme] = useState(
    "theme_Multitraslados theme_Multitrans theme_Lastrack theme_360Logistics theme_AZCommerce theme_UsoInterno "
  );

  useEffect(() => {
    (async () => {
      ShowLoad();
      await LoadParameter();
      let Companyjson = await GetCurrentCompany();
      if(!Companyjson.errorMessage){
        let CompanySession = await CompanyHook.CompanyItem(Companyjson.IdCompany);
        if(!CompanySession.errorMessage){
          await setCurrentCompany({...CompanySession,...Companyjson});
          settheme(`theme_${CompanySession.companyName.replace(" ", "")}`);
        }else {
          setHasErrorLoadCompany(true);
        }
      }else {
        setHasErrorLoadCompany(true);
      }
       HideLoad();
    })();
  }, []);


  useEffect(() => {
    //Actualizamos tema si actualizamos la compa�ia actual
    if(Company){
      //Cargamos el Tema de la Compa�ia
      if (SelectedCompany) {
        // debugger
        console.log('Company: ',SelectedCompany.companyName.replaceAll(" ", ""))
        settheme(`theme_${SelectedCompany.companyName.replaceAll(" ", "")}`);
      } else settheme(`theme_${Company.companyName.replaceAll(" ", "")}`);
    }
  }, [Company,SelectedCompany]);

  

  return (
    <I18nextProvider i18n={i18n}>
        <BrowserRouter>
          <div className={`${theme}`}>
               {
                Company ? <AppRoute /> : HasErrorLoadCompany ? <ErrorServer></ErrorServer> : <></>
               }
          </div>
          <SpinerLoad />
        </BrowserRouter>
    </I18nextProvider>
  );
};
